import { v4 as uuid } from 'uuid';
import { RootState } from 'modules/store';
import { createSlice } from '@reduxjs/toolkit';

import { AccountsState } from './accounts.types';
import {
  getAccountsAction,
  getSettlementScheduleAction,
  getSettlementSummariesAction,
} from './accounts.actions';
import { formatAccountSummary } from './accounts.helpers';

const initialState: AccountsState = {
  accounts: [],
  fetchingAccounts: false,
  accountsSummary: {
    payins: [],
    payouts: [],
  },
  fetchingSettlementSchedule: false,
  settlementSchedule: {
    application_id: '',
    settlement_schedule_cron: '',
    settlement_schedule_cron_readable: '',
    created_at: '',
    updated_at: '',
    last_updated_by: '',
  },
  fetchingSettlementSummaries: false,
  settlementSummaries: {
    content: [],
    page: {
      number: 0,
      size: 0,
      total_elements: 0,
      total_pages: 0,
      sort: [],
    },
  },
};

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // Accounts
    builder.addCase(getAccountsAction.pending, state => {
      state.fetchingAccounts = true;
    });
    builder.addCase(getAccountsAction.fulfilled, (state, { payload }) => {
      state.fetchingAccounts = false;
      state.accounts = payload.map(account => ({
        ...account,
        id: uuid(),
      }));
      state.accountsSummary = formatAccountSummary(state.accounts);
    });
    builder.addCase(getAccountsAction.rejected, state => {
      state.fetchingAccounts = false;
    });

    // Settlement Schedule
    builder.addCase(getSettlementScheduleAction.pending, state => {
      state.fetchingSettlementSchedule = true;
    });
    builder.addCase(
      getSettlementScheduleAction.fulfilled,
      (state, { payload }) => {
        state.fetchingSettlementSchedule = false;
        state.settlementSchedule = payload;
      },
    );
    builder.addCase(getSettlementScheduleAction.rejected, state => {
      state.fetchingSettlementSchedule = false;
    });

    // Settlement Summaries
    builder.addCase(getSettlementSummariesAction.pending, state => {
      state.fetchingSettlementSummaries = true;
    });
    builder.addCase(
      getSettlementSummariesAction.fulfilled,
      (state, { payload }) => {
        state.fetchingSettlementSummaries = false;
        state.settlementSummaries = payload;
      },
    );
    builder.addCase(getSettlementSummariesAction.rejected, state => {
      state.fetchingSettlementSummaries = false;
    });
  },
});

export default accountsSlice.reducer;
export const selectAccounts = (state: RootState) => state.root.accounts;
